import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", { d: "M8.002 15.16c-.167 0-.334 0-.5-.018-1.918-.157-3.558-1.297-4.382-3.057-.853-1.815-.686-3.872.454-5.502l3.344-5.188c.463-.74 1.695-.74 2.167 0l3.345 5.197c1.13 1.612 1.306 3.668.453 5.493-.824 1.76-2.464 2.9-4.381 3.057-.167.01-.324.019-.5.019Zm0-12.876L4.74 7.352s-.01.018-.019.018a4.067 4.067 0 0 0-.342 4.122c.61 1.306 1.824 2.15 3.232 2.26.26.02.52.02.77 0 1.417-.11 2.62-.954 3.232-2.26.64-1.361.51-2.9-.343-4.122L8 2.284Z" }, null, -1), r = [
  n
];
function s(l, d) {
  return e(), t("svg", c, [...r]);
}
const a = { render: s };
export {
  a as default,
  s as render
};
